import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentItemQuantityGreaterThanInventoryLevelWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.common.validation.items.quantity.greater-than-inventory-level.warning');
    }
}

export class DocumentItemQuantityGreaterThanInventoryLevelError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.items.quantity.greater-than-inventory-level.error');
    }
}
